import { CreateSoftTags } from '@/features/createTags';

export default function EditSoftTagsPage() {
  return <CreateSoftTags />;
}
